import React from 'react';
import * as S from '../GraciasPage.styles';

/**
 * Componente para mostrar el código de pago
 */
const PaymentCode = ({ label, code }) => {
  if (!code) return null;
  
  return (
    <S.PaymentCode>
      <strong>{label}</strong> {code}
    </S.PaymentCode>
  );
};

export default PaymentCode;

